"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEndpointDecoder = exports.AClientEndpoint = exports.AServerEndpoint = void 0;
class AServerEndpoint {
}
exports.AServerEndpoint = AServerEndpoint;
class AClientEndpoint {
}
exports.AClientEndpoint = AClientEndpoint;
class AEndpointDecoder {
}
exports.AEndpointDecoder = AEndpointDecoder;
